import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import LiveNotifyToast from './LiveNotifyToast';

const TransitionLeft = (props) => {
    return <Slide {...props} direction="left" />;
};

const LiveNotifyStack = (props) => {
    const { messages, onCloseToast, onOpenMessage } = props;

    return (
        <>
            {messages.map((message, index) => (
                <Snackbar
                    key={message.id}
                    open={true}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    autoHideDuration={10000}
                    onClose={() => onCloseToast(message.id)}
                    TransitionComponent={TransitionLeft}
                    style={{ top: `${16 + (index * 72)}px` }}
                >
                    <LiveNotifyToast
                        notification={message}
                        onClose={() => onCloseToast(message.id)}
                        onOpen={() => onOpenMessage(message.id)}
                    />
                </Snackbar>
            ))}
        </>
    );
};

export default LiveNotifyStack;
